<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h1>Ecommerce Dashboard</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="well">
          <form class="form-inline" @submit.prevent="applyFilters">
            <div class="form-group" style="margin-right: 10px;">
              <label for="ec-start-date">Start Date</label>
              <input type="date" id="ec-start-date" class="form-control" v-model="localFilters.start_date" />
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="ec-end-date">End Date</label>
              <input type="date" id="ec-end-date" class="form-control" v-model="localFilters.end_date" />
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="ec-granularity">Granularity</label>
              <select id="ec-granularity" class="form-control" v-model="localFilters.granularity">
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="ec-yoy">YoY Type</label>
              <select id="ec-yoy" class="form-control" v-model="localFilters.yoy_type">
                <option value="same_period">Same Period</option>
                <option value="rolling">Rolling</option>
              </select>
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="ec-top-products">Top Products</label>
              <input type="number" id="ec-top-products" class="form-control" style="width: 80px;"
                v-model.number="localFilters.top_products_limit" min="1" max="50" /> <!-- DS-PORT-DEFECT (drivescout-vue3 M6 slice 5, 2026-10-17): row S5-top-products-empty-box: an emptied box leaves v-model.number holding "" and toQueryString drops only null and undefined, so Apply sends top_products_limit= and the API answers 422 instead of the box refusing it; FIXED in the port (owner ruling 2026-10-18) -->
            </div>
            <button type="submit" class="btn btn-dc">Apply</button>
          </form>
        </div>
      </div>
    </div>

    <div v-if="error" class="row">
      <div class="col-xs-12">
        <div class="alert alert-danger">{{ error }}</div>
      </div>
    </div>

    <div v-if="loading" class="row">
      <div class="col-xs-12 text-center">
        <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
      </div>
    </div>

    <div v-if="dashboardData && !loading">
      <EcommerceSummaryCards :summary="dashboardData.summary" />

      <EcommerceYoYComparison
        v-if="dashboardData.yoy_comparison"
        :summary="dashboardData.summary"
        :yoy-comparison="dashboardData.yoy_comparison"
      />

      <div class="row">
        <div class="col-xs-12">
          <RevenueTimeSeriesChart :time-series="dashboardData.time_series" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-5">
          <TopProductsChart
            v-if="dashboardData.product_performance"
            :product-performance="dashboardData.product_performance"
          />
        </div>
        <div class="col-md-7">
          <ProductPerformanceTable
            v-if="dashboardData.product_performance"
            :product-performance="dashboardData.product_performance"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EcommerceSummaryCards from './components/EcommerceSummaryCards.vue';
import EcommerceYoYComparison from './components/EcommerceYoYComparison.vue';
import RevenueTimeSeriesChart from './components/RevenueTimeSeriesChart.vue';
import TopProductsChart from './components/TopProductsChart.vue';
import ProductPerformanceTable from './components/ProductPerformanceTable.vue';

export default {
  name: 'EcommerceDashboard',
  components: {
    EcommerceSummaryCards,
    EcommerceYoYComparison,
    RevenueTimeSeriesChart,
    TopProductsChart,
    ProductPerformanceTable
  },
  props: {
    dashboardData: { type: Object, default: null },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    filters: { type: Object, required: true },
    onFilterChange: { type: Function, required: true }
  },
  data: function() {
    return {
      localFilters: Object.assign({}, this.filters)
    };
  },
  watch: {
    filters: {
      handler: function(newVal) {
        this.localFilters = Object.assign({}, newVal);
      },
      deep: true
    }
  },
  methods: {
    applyFilters: function() {
      this.onFilterChange(Object.assign({}, this.localFilters));
    }
  }
};
</script>
